import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { APIConfiguration } from '../../../utils/apiConfiguration'

const ZRead = z.object({
  readingTime: z.string(),
  value: z.number(),
  execution_status: z.string().nullable()
})

const ZDeviceKPIReadings = z.object({
  kpiDefinitionId: z.string(),
  latestValue: z.number(),
  kpiName: z.string(),
  units: z.string(),
  alarmLowerLimit: z.number(),
  alarmHigherLimit: z.number(),
  kpiReadings: z.array(ZRead)
})

const ZAssetKPIReadings = z.object({
  kpiDefinitionId: z.string(),
  latestValue: z.number(),
  kpiName: z.string(),
  units: z.string(),
  alarmLowerLimit: z.number(),
  alarmHigherLimit: z.number(),
  kpiReadings: z.array(ZRead)
})

const ZDeviceKPIReadingsDetails = z.object({
  deviceId: z.string(),
  deviceName: z.string(),
  kpiReadings: z.array(ZDeviceKPIReadings)
})

const ZAssetKPIReadingsDetails = z.object({
  assetId: z.string(),
  assetName: z.string(),
  kpiReadings: z.array(ZAssetKPIReadings)
})

const ZIntervalReadingAssetData = z.object({
  deviceKPIReadings: z.array(ZDeviceKPIReadingsDetails),
  assetKPIReadings: z.array(ZAssetKPIReadingsDetails)
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZIntervalReadingAssetData
})

export type AssetPerformanceKPILineDataDashboard = z.infer<typeof ZIntervalReadingAssetData>
export type AssetPerformanceKPILineData = z.infer<typeof ZApiResponse>

export async function getAssetPerformanceKPILineData (
  startDate: string,
  endDate: string,
  graphName: string,
  requestParameter: any,
  isdefault: boolean,
  onSuccess: (AssetPerformanceKPILineData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/kpirest/api/v1/udp/tiq/dashboard/asset/graph/data?startDate=${startDate}&endDate=${endDate}&graphName=${graphName}&isDefault=${isdefault.toString()}`
  interceptedAxios
    .post(url, requestParameter, {
      timeout: 80000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else if (response.status === 204) {
        onFailure('No Content', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        if (error.code === 'ECONNABORTED') { onFailure(error.message, APIConfiguration.REQUEST_TIMEOUT) } else onFailure('Network Failure', error.status)
      }
    })
}
